export { UserProfilePage as default } from './user-profile'
